import { createSlice } from "@reduxjs/toolkit";

export const vendorSlice = createSlice({
  name: "vendor",
  initialState: {
    postLoading: false,
    postError: false,
    postStatusCode: 0,
    postMessage: "",
    getLoading: false,
    getError: false,
    getData: null,
    getMessage: "",
    getStatusCode: 0,
  },
  reducers: {
    onVendorPost: (state) => ({
      ...state,
      postLoading: true,
      postError: false,
      postStatusCode: 0,
      postMessage: "",
    }),
    onVendorPostSuccess: (state, { payload }) => {
      const { message = "", status_code = 200 } = payload;
      return {
        ...state,
        postLoading: false,
        postError: false,
        postStatusCode: status_code,
        postMessage: message,
      };
    },
    onVendorPostError: (state, { payload }) => {
      const { message = "", status_code = 400 } = payload;
      return {
        ...state,
        postLoading: false,
        postError: true,
        postStatusCode: status_code,
        postMessage: message,
      };
    },
    onVendorPostReset: (state) => ({
      ...state,
      postLoading: false,
      postError: false,
      postStatusCode: 0,
      postMessage: "",
    }),
    onGetVendors: (state) => ({
      ...state,
      getLoading: true,
      getError: false,
      getData: null,
      getMessage: "",
      getStatusCode: 0,
    }),
    onGetVendorsSuccess: (state, { payload }) => {
      const { data = null, message = "", status_code = 200 } = payload;
      return {
        ...state,
        getLoading: false,
        getError: false,
        getData: data,
        getMessage: message,
        getStatusCode: status_code,
      };
    },
    onGetVendorsError: (state, { payload }) => {
      const { data = null, message = "", status_code = 400 } = payload;
      return {
        ...state,
        getLoading: false,
        getError: true,
        getData: data,
        getMessage: message,
        getStatusCode: status_code,
      };
    },
    onGetVendorsReset: (state) => ({
      ...state,
      getLoading: false,
      getError: false,
      getData: null,
      getMessage: "",
      getStatusCode: 0,
    }),
  },
});

export const {
  onVendorPost,
  onVendorPostSuccess,
  onVendorPostError,
  onVendorPostReset,
  onGetVendors,
  onGetVendorsSuccess,
  onGetVendorsError,
  onGetVendorsReset,
} = vendorSlice.actions;

export default vendorSlice.reducer;
